import React from 'react'
import NavTest from '../NavTest'

export default function Navbar() {
  return (
    <NavTest />
  )
}
